import axiosInstance from '../RestClient';

const BASE_URI = '/config';
class ConfigService {
	async list() {
		const uri = `${BASE_URI}/`;
		const response = await axiosInstance.get(uri);
		return response;
	}

	async listPublic() {
		const uri = `${BASE_URI}/public`;
		const response = await axiosInstance.get(uri);
		return response;
	}
	async getTabs () {
		const uri = `${BASE_URI}/tabs`;
		const response = await axiosInstance.get(uri);
		return response;
	}

	async updateTabs(tabs) {
		const uri = `${BASE_URI}/tabs`;
		const response = await axiosInstance.put(uri, { tabs });
		return response;
	}
	async getNotificationPreferences() {
		const res = await axiosInstance.get(`${BASE_URI}/notificationPreferences`);
		return res;
	}

	// async getDetails(recordId) {
	//     const uri = `${BASE_URI}/${recordId}`;
	//     const response = await axiosInstance.get(uri);
	//     return response;
	// }

	// async create(payload) {
	//     const response = await axiosInstance.post(
	//       `${BASE_URI}/`,
	//       payload,
	//
	//     );
	//     return response;
	// }

	async edit(payload) {
		const response = await axiosInstance.put(`${BASE_URI}/`, payload);
		return response;
	}

	// async delete(recordId) {
	//     const uri = `${BASE_URI}/${recordId}`;
	//     const response = await axiosInstance.delete(uri, {
	//
	//     });
	//     return response;
	// }

	async uploadSettingsImage(formData) {
		const uri = `${BASE_URI}/uploadSettingsImg`;
		const response = await axiosInstance.post(uri, formData, {
			headers: { 'Content-Type': undefined },
		});
		return response;
	}

	async updateEmails(payload) {
		const response = await axiosInstance.put(`${BASE_URI}/emails`, payload);
		return response;
	}

	async updateIpc(payload) {
		const response = await axiosInstance.put(`${BASE_URI}/ipc`, payload);
		return response;
	}

	async getDashboardModules() {
		const uri = `${BASE_URI}/dashboard-modules`;
		const response = await axiosInstance.get(uri);
		return response;
	}

	async updateDashboardModules(dashboardModules) {
		const uri = `${BASE_URI}/dashboard-modules`;
		const response = await axiosInstance.put(uri, { dashboardModules });
		return response;
	}

	async getTerminology() {
		const uri = `${BASE_URI}/terminology`;
		const response = await axiosInstance.get(uri);
		return response;
	}

	async getBusinessPresets() {
		const response = await axiosInstance.get(`${BASE_URI}/presets`);
		return response;
	}

	async reapplyBusinessPreset() {
		const response = await axiosInstance.post(`${BASE_URI}/preset/reapply`, {});
		return response;
	}

	async updateTerminology(overrides) {
		const uri = `${BASE_URI}/terminology`;
		const response = await axiosInstance.put(uri, { overrides });
		return response;
	}

	async previewDuplicateDues() {
		const response = await axiosInstance.get(`${BASE_URI}/duplicate-dues/preview`);
		return response;
	}

	async cleanupDuplicateDues(selectedGroups) {
		const body =
			Array.isArray(selectedGroups) && selectedGroups.length > 0
				? { selectedGroups }
				: {};
		const response = await axiosInstance.post(`${BASE_URI}/duplicate-dues/cleanup`, body);
		return response;
	}
}
export default new ConfigService();
